import Button from 'components/Button';
import { ROUTES } from 'config';
import classes from 'styles/User.module.scss';
import Paginate from 'components/Paginate';
import Table from 'components/Table';
import useFilters from 'hooks/useFilters';
import { useState } from 'react';
import { Menu, MenuItem, MenuButton } from '@szhsin/react-menu';
import arrowDownBlack from 'assets/arrow-down-black.svg';
import usePartnersPaginate from 'hooks/usePartnersPaginate';
import PartnerScreen from 'components/partnersScreen';
import exportFromJSON from 'export-from-json';

// const filterList: FilterListItem[] = [
//   {
//     field: 'kycStatus',
//     label: 'KYC',
//     options: [
//       { value: true, label: 'Approved' },
//       { value: false, label: 'Not Applied' },
//     ],
//   },
// ];

// const submitHandler = () => {
//   console.log('View Details button');
// };

export default function PbankDetails() {
  const { filters } = useFilters();
  // const { headers } = usePartners();
  const [searchValue, setSearchValue] = useState<String>('');
  const [searchField, setSearchField] = useState<any>('name'); // ? name || phone_no || email

  const [searchValueSubmitted, setSearchValueSubmitted] = useState<String>('');
  const [banks, { paginateProps, loading }] = usePartnersPaginate<any>(
    {
      route: ROUTES.Partners_BANK_LIST,
      params: {
        filters: {
          [searchField]: searchValue,
          ...filters,
        },
      },
      filterData: (data) => (data.data.walletList ? data.data.walletList : []),
    },
    [searchValueSubmitted, filters],
  );

  const exportToExcel = (data: any, fileName: any, exportType: any) => {
    exportFromJSON({ data, fileName, exportType });
  };

  const handleSearchSubmit = (event: any) => {
    event.preventDefault();

    setSearchValueSubmitted(() => searchValue);
  };

  // ? Method to render the dropdown title
  const renderDropdownTitle = () => {
    switch (searchField) {
      case 'name':
        return 'Name';
    }
  };
  // * End of renderDropdownTitle();

  return (
    <PartnerScreen className={classes.container}>
      <div className={classes.usersTitleSection}>
        <h3>Bank Details</h3>
        <button
          className={classes.ExportBtn}
          style={{ padding: '11px !important' }}
          onClick={() => {
            exportToExcel(banks, 'Bank Details', 'csv');
          }}
        >
          Export
        </button>
        {/*<Filters
          filters={filters}
          updateFilters={updateFilters}
          filterList={filterList}
        />  */}

        <form className={classes.userSearchForm} onSubmit={handleSearchSubmit}>
          <div className={classes.searchInputSection}>
            <input
              type="text"
              placeholder={
                searchField === 'name'
                  ? 'Search Name'
                  : searchField === 'email'
                  ? 'Search Email'
                  : 'Ph: 91 12345-67890'
              }
              onChange={(event) => setSearchValue(event?.target.value)}
            />
            <Menu
              menuButton={
                <MenuButton className={classes.dropdownBtn}>
                  <span>{renderDropdownTitle()}</span>
                  <img src={arrowDownBlack} alt="arrow-img" width={10} />
                </MenuButton>
              }
              transition
              menuClassName="drop-down"
              onItemClick={(e: any) => setSearchField(e.value)}
            >
              <MenuItem
                value="name"
                className={
                  searchField === 'name' ? 'dropdown-item-selected' : ''
                }
              >
                Name
              </MenuItem>
            </Menu>
          </div>
          <Button loading={loading} type="submit">
            Search
          </Button>
        </form>
      </div>

      <Table loading={loading} height="75%">
        <thead>
          <tr>
            <th>Fiat Currency</th>
            <th>Bank Account Number</th>
            <th>Benificiary Bank Number</th>
          </tr>
        </thead>
        <tbody>
          {banks.map(
            (
              { fiatCurrency, bankAccountNumber, beneficiaryBankName },
              index,
            ) => (
              <tr key={index}>
                <td>{fiatCurrency}</td>
                <td>{bankAccountNumber}</td>
                <td>{beneficiaryBankName}</td>
              </tr>
            ),
          )}
        </tbody>
      </Table>
      <div className={classes.foot}>
        <Paginate {...paginateProps} />
      </div>
    </PartnerScreen>
  );
}
